import { useEffect } from 'react';

import { useUserInfoActions } from '../../store/userInfoStore';
import { useHasBillingInformation } from '../useHasBillingInformation';

export const useLoadBillingInformationToStore = (skip: boolean) => {
	const { setHasBillingInformation } = useUserInfoActions();
	const { hasBillingInformation, loading, error } = useHasBillingInformation(skip);

	useEffect(() => {
		if (!loading && !error) {
			void setHasBillingInformation(hasBillingInformation);
		}
	}, [error, hasBillingInformation, loading, setHasBillingInformation]);
};
